import styled from 'styled-components';
import { mq, getGridSpans, getSpace, px2rem } from '../../../stylesheets/tools';

const dotsImage = '/static/dots/dots.png';

const imageHeightDesktop = px2rem('380px');
const imageHeightTablet = px2rem('355px');
const imageHeightMobile = px2rem('280px');

const marginTopDesktop = px2rem('200px');
const marginTopMobile = px2rem('100px');

const StyledMainStage = styled.section`
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: ${getSpace('l')};
  background: ${props => props.theme.globalTheme.primary};

  .mainStage__headline {
    text-align: center;
    margin-top: 42px;
    ${getGridSpans('margin-left', { s: 0, m: [1, 'spread'] })}
    ${getGridSpans('width', { s: 12, m: 10 })}

    ${mq('m')} {
      margin-top: 76px;
    }

    ${mq('l')} {
      margin-top: 75px;
    }
  }

  .mainStage__subline,
  .mainStage__copy {
    position: relative;
    margin: 0;
    ${getGridSpans('margin-left', { s: [1, 'spread'] })}
    ${getGridSpans('margin-right', { s: [1, 'spread'] })}
    padding-left: 2px;
    display: block;
    z-index: 2;
  }

  .mainStage__logo {
    width: 100%;
    max-width: 890px;
    position: relative;
    z-index: 2;
    margin: 20px auto;

    &-wrapper {
      margin: 0 ${getSpace('xs')};

      ${mq('l')} {
        margin: 0;
      }
    }

    svg {
      width: 100%;
      height: auto;
    }
  }

  .mainStage__background {
    position: absolute;
    top: ${marginTopMobile};
    left: 0;
    width: 100%;
    height: 100vh;
    background: ${props => props.theme.globalTheme.primary};

    ${mq('xxl')} {
      top: ${marginTopDesktop};
    }
  }

  .mainStage__wrapper {
    padding-top: ${marginTopMobile};

    ${mq('xxl')} {
      padding-top: ${marginTopDesktop};
    }
  }


  .mainStage__dots {
    position: relative;
    top: ${imageHeightMobile};
    height: calc(100% - ${imageHeightMobile});
    width: 100%;
    background: rgba(0, 0, 0, 0.1);

    &:before {
      position: absolute;
      content: '';
      width: 100%;
      height: ${imageHeightMobile};
      top: -${imageHeightMobile};
      background-image: url(${dotsImage});
      background-size: auto 100%;
      background-repeat: repeat;
      background-position: center center;
      opacity: 0.1;
    }

    ${mq('s')} {
      top: ${imageHeightTablet};
      height: calc(100% - ${imageHeightTablet});

      &:before {
        height: ${imageHeightTablet};
        top: -${imageHeightTablet};
      }
    }

    ${mq('l')} {
      top: ${imageHeightDesktop};
      height: calc(100% - ${imageHeightDesktop});

      &:before {
        height: ${imageHeightDesktop};
        top: -${imageHeightDesktop};
      }
    }
  }

  .mainStage__curtain-right,
  .mainStage__curtain-left {
    position: fixed;
    height: 120vh;
    box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.1);
    z-index: 1;
    transition: transform 0.2s cubic-bezier(0.48, 0, 0.5, 1);

  }

  .mainStage__curtain-left {
    width: 150vw;
    top: 70vh;
    left: 0;
    transform: translateY(100%) rotate(15deg);
    transform-origin: top left;
    background: ${props => props.theme.globalTheme.secondary};

    ${mq('l')} {
      top: 60vh;
    }
  }

  .mainStage__curtain-right {
    height: 120vh;
    width: 150vw;
    top: 50vh;
    right: 0;
    left: auto;
    transform: translateY(100%) rotate(-50deg);
    transform-origin: top right;
    background: ${props => props.theme.globalTheme.tertiary};

    ${mq('l')} {
      height: 120vh;
      width: 150vw;
      top: -20vh;
      right: 0;
    }
  }
`;

export default StyledMainStage;
